import { AuthConfig, SignOutOptions } from '../types/types'
import cookieHandler from '../handlers/cookieHandler'

export default (config: AuthConfig) => {
  const cookie = cookieHandler()

  return (options: SignOutOptions = {}): void => {
    const provider = cookie.getProvider()
    const idToken = cookie.getIdToken()

    let url = `${config.authServerUrl}/${provider}/signout?id_token=${idToken}`

    if (options.returnUrl) {
      url = `${url}${url.indexOf('?') === -1 ? '?' : '&'}`
      url = `${url}return_url=${options.returnUrl}`
    }

    if (options.bounceUrl) {
      url = `${url}${url.indexOf('?') === -1 ? '?' : '&'}`
      url = `${url}bounce_url=${options.bounceUrl}`
    }

    cookie.clearTokens()
    cookie.clearCookiesOnSignOut()

    location.href = url
  }
}
